import React, { FC, ReactNode, useEffect, useRef, useState } from 'react'
import { ButtonComponent } from 'Pages/landings/newLandings/common/components'
import { Callback } from 'Pages/landings/common/types'
import { CloseIcon } from './Icon'
import { ModalWrapper, Modal, Header, Title, ScrollBlock, Footer } from './styled'

interface ComponentProps {
	closeModal: Callback
	children?: ReactNode
	title?: string
	button?: () => Callback
	className?: string
	buttonType?: string
}

export const ModalFullComponent: FC<ComponentProps> = ({
	closeModal,
	children,
	title,
	button,
	className,
	buttonType = 'primary',
}) => {
	const [isClick, setIsClick] = useState<boolean>(false)
	const [hModal, setHModal] = useState<number>(0)
	const refModal = useRef(null)
	useEffect(() => {
		setHModal(refModal.current?.clientHeight + 1)
		document.body.style.overflowY = 'hidden'
		return () => {
			document.body.style.overflowY = 'auto'
		}
	}, [])
	const close = () => {
		setIsClick(true)
		setTimeout(() => closeModal(), 500)
	}
	return (
		<ModalWrapper hModal={hModal} isClick={isClick} isOpen={Boolean(title)} onClick={close}>
			<Modal
				ref={refModal}
				hModal={hModal}
				isClick={isClick}
				isOpen={Boolean(title)}
				className={className}
				onClick={(e) => e.stopPropagation()}
			>
				<Header>
					{title && <Title>{title}</Title>}
					<div onClick={close}>
						<CloseIcon />
					</div>
				</Header>
				<ScrollBlock>
					{children}
					<Footer isButtons={Boolean(button)}>
						{button ? (
							<>
								{button?.()}
								<ButtonComponent type="tertiary" measure="l" text="Закрыть" onClick={close} />
							</>
						) : (
							<ButtonComponent type={buttonType} measure="l" text="Закрыть" onClick={close} />
						)}
					</Footer>
				</ScrollBlock>
			</Modal>
		</ModalWrapper>
	)
}
